import { render, staticRenderFns } from "./TaskViewer.vue?vue&type=template&id=6dbf31c7&scoped=true&"
import script from "./TaskViewer.vue?vue&type=script&lang=js&"
export * from "./TaskViewer.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewer.vue?vue&type=style&index=0&id=6dbf31c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf31c7",
  null
  
)

export default component.exports